<div class="modal-body" style="min-height: 350px;">
    <div class="mb-5">
        <h3 class="text-center mb-2">Assign policy to
            {{revokePolicyFlowSharedData.selectedUsers.length===1?revokePolicyFlowSharedData.selectedUsers[0].fullName:revokePolicyFlowSharedData.selectedUsers.length+'
            users'}}</h3>
    </div>
    <div>
        <div class="mb-4">You are about to assign <span
                class="fw-semibold">{{revokePolicyFlowSharedData.selectedPolicy.title}}</span>
            to <span
                class="fw-semibold">{{revokePolicyFlowSharedData.selectedUsers.length===1?revokePolicyFlowSharedData.selectedUsers[0].fullName:revokePolicyFlowSharedData.selectedUsers.length+'
                User'}}</span>
        </div>

        <div class="mb-4">
            <div class="form-group">
                <label for="new-version" class="f-small text-neutral-800">Select how user will be notified</label>
                <select [(ngModel)]="newVersion" class="form-control custom-select" name="new-version"
                    id="new-version" style="max-width: 600px">
                    <ng-container *ngFor="let option of NEW_VERSION_TO_OPTION_DISPLAY | keyvalue: originalOrder">
                        <option [ngValue]="option.key">{{option.value}}</option>
                    </ng-container>
                </select>
            </div>
        </div>

        @if(newUsers().length>0){
        <app-addflow-confirm-users [selectedUsers]="newUsers()">
            <p paragraph class="fw-semibold">{{newUsers().length+' user' | addPluralS}} will be assigned this policy</p>
        </app-addflow-confirm-users>
        }

        @if(existingUsers().length>0){
        <app-addflow-confirm-users [selectedUsers]="existingUsers()">
            <p paragraph class="fw-semibold">{{existingUsers().length+' user' | addPluralS}} will be required to
                reacknowledge this policy
            </p>
        </app-addflow-confirm-users>
        }

    </div>
    <div class="d-flex justify-content-center" *ngIf="error">
        <p class="text-danger f-small">{{error}}</p>
    </div>
</div>

<!-- FOOTER -->
<div class="modal-footer d-flex justify-content-between">
    <button type="button" class="btn btn-outline-light" [disabled]="revokingPolicy"
        (click)="stepsControl.previousStep();">
        Back
    </button>
    <button type="button" class="btn btn-secondary"
        [disabled]="revokingPolicy || (existingUsers().length===0 && newUsers().length===0)"
        (click)="revokePolicy()"><span *ngIf="revokingPolicy" style="color: inherit">
            <ui-spinner size="sm" class="me-1" color="light"></ui-spinner>
        </span>Assign</button>
</div>